<template>
  <div class="max-w-5xl mx-auto mt-5">
    <OnlineStore2Support class="mb-20" v-if="config" />
  </div>
</template>

<script>
import OnlineStore2Support from "../../components/Chat/OnlineStore2Support";

export default {
  components: {
    OnlineStore2Support
  },
  data() {
    return {
      config: {}
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const response = await this.$store.dispatch("getChatConfig");
      this.config = response.config;
    }
  }
};
</script>

<style lang="scss" scoped></style>
